export const WARNING_THRESHOLD = 10;
export const CRITICAL_THRESHOLD = 3;
export const DEFAULT_RATE_LIMIT = 50;
